module.exports = __webpack_public_path__ + "img/open_brower.81244c14.png";